module.exports = __webpack_public_path__ + "static/media/Bay7.fa8bf438.JPG";